var map = {
	"./designed-session.png": 1158,
	"./designed-session.svg": 1159,
	"./group-play.png": 1160,
	"./group-play.svg": 1161,
	"./info.svg": 451,
	"./quick-session.png": 1162,
	"./quick-session.svg": 1163,
	"./single-game.png": 1164,
	"./single-game.svg": 1165
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/play-screen-icons ^\.\/.*$
// module id = 212
// module chunks = 0